import axios from "axios";
import { useCallback, useContext, useEffect, useState } from "react";
import {
  //  useNavigate,
  useParams,
} from "react-router-dom";
import { toast } from "react-toastify";

import { Context } from "../../context/context";
import { Button, Card, Field, PageSpinner, TextInput } from "../../components/ui";

const DeviceSettings = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [nickname, setNickname] = useState("");
  const [selectedTimezone, setSelectedTimezone] = useState("");
  const [error, setError] = useState("");

  const { dispatch } = useContext(Context);
  const { deviceId } = useParams();
  // const navigate = useNavigate();

  const getSettingsData = useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`/app-api/device/${deviceId}/settings`);
      setNickname(data.nickname || "");
      setSelectedTimezone(data.timezoneValue || "");
    } catch (err) {
      console.error(err);
      toast.error("Failed to load data");
    } finally {
      setIsLoading(false);
    }
  }, [deviceId]);

  useEffect(() => {
    getSettingsData();
  }, [getSettingsData]);

  const handleSave = async () => {
    if (isSaving) return;
    if (!nickname.trim()) {
      setError("Enter a nickname for this device.");
      return;
    }
    setError("");
    setIsSaving(true);
    try {
      await axios.post(`/app-api/device/${deviceId}/nickname`, { nickname: nickname.trim() });
      dispatch({ type: "CHANGE_NICKNAME", payload: { deviceId, nickname: nickname.trim() } });
      toast.success("Settings updated!");
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <PageSpinner />;

  return (
    <>
      <p className="mb-5 text-sm text-gray-500">How this MedpeR appears across the app.</p>

      <Card className="max-w-lg p-5 nav:p-6">
        <Field label="Nickname" error={error} htmlFor="device-nickname">
          <TextInput
            id="device-nickname"
            type="text"
            value={nickname}
            invalid={Boolean(error)}
            placeholder="Enter nickname"
            onChange={(e) => setNickname(e.target.value)}
          />
        </Field>

        <Field label="Device Timezone" htmlFor="device-timezone" hint="Alarm times are shown in this timezone. Change it from the device itself.">
          <TextInput id="device-timezone" type="text" value={selectedTimezone} readOnly />
        </Field>

        <Button onClick={handleSave} loading={isSaving}>
          Save
        </Button>
      </Card>

      {/* <Card className="mt-5 max-w-lg p-5 nav:p-6">
        <p className="text-sm font-bold text-primary-900">WiFi & connectivity</p>
        <p className="mt-1 text-xs text-gray-500">Moved to a new home or changed your router? Reconnect it here.</p>
        <Button
          variant="secondary"
          size="sm"
          className="mt-4"
          onClick={() => navigate(`/wifi-setup?deviceId=${deviceId}`)}
        >
          Reconfigure WiFi
        </Button>
      </Card> */}
    </>
  );
};

export default DeviceSettings;
